'use client';

import * as React from 'react';
// import { useAppSelector } from '@/store/hooks';
// import { getDrawerContent } from '@/store/reducers/drawer-content-slice';
import { Button, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';

import { SettingsSection } from '@/components/core/settings-section';

export function ActionsTab(): React.JSX.Element {
  // const { DOMAIN_DETAILS } = useAppSelector(getDrawerContent);

  return (
    <Stack direction="column" gap={2}>
      <SettingsSection
        title="Set As Primary"
        content={
          <Stack gap={2}>
            <Typography>Set the domain as primary domain.</Typography>
            <Box>
              <Button variant="contained" color="success">
                Set Primary
              </Button>
            </Box>
          </Stack>
        }
      />
      <SettingsSection
        title="Set As Primary"
        content={
          <Stack gap={2}>
            <Typography>Set the domain as primary domain.</Typography>
            <Box>
              <Button variant="contained" color="success">
                Set Primary
              </Button>
            </Box>
          </Stack>
        }
      />
      <SettingsSection
        title="Set As Primary"
        content={
          <Stack gap={2}>
            <Typography>Set the domain as primary domain.</Typography>
            <Box>
              <Button variant="contained" color="error">
                Force Delete
              </Button>
            </Box>
          </Stack>
        }
      />
    </Stack>
  );
}
